import * as tslib_1 from "tslib";
import React from 'react';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next';
import UserAvatar from '../User/Avatar';
import LoadingIndicator from '../LoadingIndicator';
import ElementQueries from '../ElementQueries';
import { EditorFlavourConfigs } from '../DaEditorWrapper/config';
import DaEditorWrapper from '../DaEditorWrapper/LoadableDaEditorWrapper';
import { IS_EMPTY_FEATURE } from '../DaEditorWrapper/Features/isEmpty';
import mergeTheme from '../DaEditorWrapper/Themes/mergeTheme';
import LazyPlaceholder from './_partials/LazyPlaceholder';
import DisabledComment from '../DisabledComment';
import s from './CommentBox.scss';
// Merge the text theme with the editor theme (content vs editor toolbars etc)
import commentTextTheme from '../DaEditorWrapper/Themes/Viewer/comments.scss';
import commentEditorTheme from '../DaEditorWrapper/Themes/Editor/comments.scss';
import { withMobileContext } from '../Context';
import CommentForAnonymous from '../CommentForAnonymous';
import { withVerification, } from '../VerificationPopup/withVerification';
var editorTheme = mergeTheme(commentTextTheme, commentEditorTheme);
var Loader = function () { return React.createElement(LoadingIndicator, { className: s['loader'] }); };
var CommentBox = /** @class */ (function (_super) {
    tslib_1.__extends(CommentBox, _super);
    function CommentBox(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isEmpty: true,
            isEdit: false,
            isExpanded: true,
            footerToolbar: undefined,
        };
        _this.postComment = function () {
            var _a = _this.props, id = _a.id, isBusy = _a.isBusy, editComment = _a.editComment, replyComment = _a.replyComment, commentableType = _a.commentableType, commentableItemId = _a.commentableItemId, isVerificationNeeded = _a.isVerificationNeeded, pushVerificationPopup = _a.pushVerificationPopup, onPublishComment = _a.onPublishComment;
            if (isBusy) {
                return;
            }
            if (isVerificationNeeded) {
                pushVerificationPopup('comment');
                return;
            }
            onPublishComment &&
                onPublishComment({
                    editorId: id,
                    typeId: commentableType,
                    itemId: commentableItemId,
                    rawContentState: _this.editorRawState,
                    editorContent: _this.editorContent,
                    featuresData: _this.editorFeatures,
                    editComment: editComment,
                    replyComment: replyComment,
                });
        };
        _this.handleEditorChange = function (rawContentState, editorContent, featuresData) {
            _this.editorRawState = rawContentState;
            _this.editorContent = editorContent;
            _this.editorFeatures = featuresData;
            _this.featureChange(featuresData);
        };
        _this.expand = function () {
            _this.setState({ isExpanded: true });
        };
        _this.startCollapse = function () {
            _this.timer = setTimeout(_this.collapse, 300);
        };
        _this.collapse = function () {
            if (!_this.state.isEdit && _this.state.isEmpty) {
                _this.setState({ isExpanded: false });
            }
        };
        _this.cancel = function () {
            var _a = _this.props, t = _a.t, onClose = _a.onClose;
            clearTimeout(_this.timer);
            if (!_this.state.isEdit && !_this.state.isEmpty) {
                var cancel = confirm(t('commentbox.editor.cancel.confirm'));
                if (cancel) {
                    _this.editorApi.clearEditor();
                    _this.setState({ isEmpty: true });
                }
            }
            _this.setState({ isExpanded: false });
            onClose && onClose();
        };
        _this.featureChange = function (features) {
            for (var _i = 0, features_1 = features; _i < features_1.length; _i++) {
                var feature = features_1[_i];
                if (feature.type === IS_EMPTY_FEATURE) {
                    _this.setState({ isEmpty: feature.data.isEmpty });
                }
            }
        };
        _this.handleEditorReady = function (toolbars, api) {
            _this.editorApi = api;
            if (!_this.state.footerToolbar && toolbars.FOOTER) {
                _this.setState({ footerToolbar: toolbars.FOOTER });
            }
            if (_this.props.focus) {
                _this.props.focusDone && _this.props.focusDone(_this.props.id);
            }
        };
        _this.state.isEdit = props.editComment ? true : false;
        _this.state.isExpanded = _this.state.isEdit || props.focus;
        if (_this.state.isEdit && props.editComment) {
            _this.initialContent = props.editComment.textContent;
        }
        return _this;
    }
    // TODO remove this its deprecated
    CommentBox.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.publishResult) {
            !this.state.isEdit && this.editorApi.clearEditor();
            this.setState({
                isExpanded: false,
            });
        }
        if (nextProps.focus) {
            this.setState({ isExpanded: true });
        }
    };
    CommentBox.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.props, publishResult = _a.publishResult, onPublishSuccess = _a.onPublishSuccess, errorMsg = _a.errorMsg, onEditorChanged = _a.onEditorChanged;
        if (publishResult && prevProps.publishResult !== publishResult) {
            onPublishSuccess && onPublishSuccess(publishResult);
        }
        if ((errorMsg || publishResult) && onEditorChanged) {
            onEditorChanged({ editorId: this.props.id }); // Clear last result/error
        }
    };
    CommentBox.prototype.render = function () {
        var _a = this.props, t = _a.t, user = _a.user, className = _a.className, isBusy = _a.isBusy, isError = _a.isError, isMobile = _a.isMobile, isLoggedIn = _a.isLoggedIn, tabIndexBase = _a.tabIndexBase, focus = _a.focus, replyComment = _a.replyComment, canPostComment = _a.canPostComment;
        var _b = this.state, isExpanded = _b.isExpanded, isEmpty = _b.isEmpty;
        // We always want to focus because the lazy placeholder click wants
        // focus right away, but we allow that to be overridden
        var shouldFocus = focus !== false;
        return (React.createElement(ElementQueries, { id: this.props.id, className: classnames(s['commentbox'], className, isExpanded && s['expanded'], isExpanded && 'focused'), widthBreakpoints: [490] }, !canPostComment && isLoggedIn ? (React.createElement(DisabledComment, { title: t('Comments are disabled') })) : (React.createElement(React.Fragment, null,
            React.createElement(UserAvatar, { user: user, className: s['commentbox-avatar'], withLink: isLoggedIn }),
            React.createElement("div", { className: classnames(s['commentbox-content'], 'da-editor-comment') }, isLoggedIn ? (React.createElement(React.Fragment, null,
                isError && this.renderError(),
                isBusy && React.createElement(LoadingIndicator, { className: s['loading'] }),
                React.createElement(DaEditorWrapper, { staticComponent: LazyPlaceholder, loadingComponent: Loader, forceLoadOnMount: !!this.initialContent || replyComment, flavour: EditorFlavourConfigs.COMMENT, editorKey: this.props.id, theme: editorTheme, onEditorInit: this.handleEditorReady, initialContent: this.initialContent || undefined, placeholder: t('commentbox.editor.placeholder'), "aria-label": this.props['aria-label'], "aria-labelledby": this.props['aria-labelledby'], onFocus: this.expand, onContentChange: this.handleEditorChange, onKeyboardSubmit: this.postComment, tabIndex: tabIndexBase || 0 + 1, filterPaste: true, autoFocus: shouldFocus }),
                React.createElement("footer", { className: s['commentbox-footer'] },
                    this.renderFooterToolbar(),
                    !isMobile && (React.createElement("button", { tabIndex: tabIndexBase || 0 + 3, disabled: isBusy, className: classnames(s['commentbox-cancel-button'], s['comment-button-activated']), onClick: this.cancel }, t('commentbox.button.cancel'))),
                    React.createElement("button", { tabIndex: tabIndexBase || 0 + 2, disabled: isEmpty || isBusy, className: classnames(s['commentbox-comment-button'], isEmpty && s['comment-button-disabled']), onFocus: this.expand, onClick: this.postComment }, this.state.isEdit
                        ? t('commentbox.button.update')
                        : t('commentbox.button.comment'))))) : (React.createElement(CommentForAnonymous, null)))))));
    };
    CommentBox.prototype.renderError = function () {
        // TODO get designers to make nice errors
        if (this.props.errorMsg) {
            alert(this.props.errorMsg);
        }
    };
    CommentBox.prototype.renderFooterToolbar = function () {
        var footerToolbar = this.state.footerToolbar;
        if (!footerToolbar) {
            return;
        }
        var FooterToolbar = footerToolbar;
        return (React.createElement("div", { className: s['footerToolbar'] },
            React.createElement(FooterToolbar, null)));
    };
    CommentBox.defaultProps = {
        tabIndexBase: 0,
        canPostComment: true,
    };
    return CommentBox;
}(React.PureComponent));
export { CommentBox };
export default withVerification(withMobileContext(withTranslation()(CommentBox)));
//# sourceMappingURL=CommentBox.js.map